document.addEventListener("DOMContentLoaded", function () {
    document.querySelector("#p_lt_content_plcMain_p_lt_ctl05_TL_BizForm_viewBiz_btnOK").addEventListener("click", function (e) {
        e.preventDefault(); // Prevent default form submission

        // Uzimanje vrednosti iz input polja
        var name = document.querySelector("#name").value;
        var phone = document.querySelector("#phone").value;
        var postcode = document.querySelector("#postcode").value;
        var preference = document.querySelector("input[name='p$lt$content$plcMain$p$lt$ctl05$TL_BizForm$viewBiz$Voorkeur$list']:checked").value;
        var token = document.querySelector("#recaptchaToken").value;

        // Kreiranje objekta sa podacima koji će se poslati
        var data = {
            name: name,
            phone: phone,
            postcode: postcode,
            preference: preference
        };
        var queryString = "?name=" + encodeURIComponent(name) +
            "&phone=" + encodeURIComponent(phone) +
            "&postcode=" + encodeURIComponent(postcode) +
            "&preference=" + encodeURIComponent(preference) +
            "&recaptchaToken=" + encodeURIComponent(token);
        // Slanje podataka na C# kontroler koristeći Fetch API
        fetch("/umbraco/surface/ContactForm/Send" + queryString, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then(function (responseData) {
                window.location.href = "/home/bel-mij-terug/bedankt"; 
            })
            .catch(function (error) {
                console.error(error);
            });
    });
});